export default {
  methods: {
    getParams(){
      const url = new URL(window.location.href);
      const params = url.searchParams;
      if(params.size !== 0){
        const subject = 8;
        const id = params.get('a');
        const token = params.get('b');
        if(id && token) {
          return {
            subject: subject,
            id: id,
            token: token,
            referrer: document.referrer.indexOf(process.env.VUE_APP_LINK_BASE) !== -1,
          };
        }else {
          return false;
        }
      }else{
        return false;
      }
    }
  }
}
